var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 698,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 489,
	"./assets/thewest-digital-hero-variation-a.jpg": 699,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 700,
	"./assets/thewest-digital-hero-variation-b.jpg": 2590,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 701,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2591,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 702,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2592,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 703,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2593,
	"./assets/thewest-digital-hero.jpg": 2594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2589;